/**
 * Where a chat opens. Every chat — plain or project/Workroom — opens in the
 * Assistant: /assistant/:chatId loads it via GetConversation and carries its
 * projectId into ChatView. Shared by the full History view and the Assistant rail
 * so the two cannot disagree.
 */ export function chatHref(chat) {
    return `/assistant/${chat.chatId}`;
}
